import React, { FunctionComponent } from "react";
import NextNProgress from "nextjs-progressbar";

const ProgressBarComponent: FunctionComponent = () => {
  return <NextNProgress color="#0d6efd" height={3} showOnShallow={true} />;
};

export default React.memo(ProgressBarComponent);
